import { isProcessClient } from "~/utils/process"
import window from "~/utils/window"

export default isProcessClient() ? window.location : {} as Location
